module.exports = __webpack_public_path__ + "media/images/placeholders/team-cc2b67e1d5d179b450b728e8bfae406d.jpg";